<template>
    <div role="tab"
         id="tab-physical"
         tabindex="10"
         @keydown.enter.prevent="$emit('click')"
         @keydown.space.prevent="$emit('click')"
    >
        <div>
            <span class="label">
                {{ label }}
            </span>
        </div>
        <div v-if="['FR', 'BE'].indexOf(country) >= 0 && display_price">
            <span class="price">
                {{ useFormatPrice(price) }} &euro;<sup>*</sup>
            </span>
        </div>
    </div>
</template>
<script setup>
import {useFormatPrice} from "../composables.js";
import {computed} from "vue";
import {trans} from "laravel-vue-i18n";

const props = defineProps({
    country: [String],
    price: [Number, String],
    format_id: Number,
    display_price: Boolean
});

const label = computed(() => {
    if (props.format_id === 32) {
        return trans('Format CD');
    }
    return trans('Livre papier')
});
</script>
